<template>
  <van-popup
    v-model="showPicker"
    class="service-pop"
    position="right"
    closeable
    style="width: 100%; height: 100%; z-index: 10000"
  >
    <div class="page-wrap">
      <div class="top-bg"></div>
      <div class="bottom-bg"></div>
      <div class="page-main">
        <div class="header">
          <div class="tit"></div>
          <div class="sub-tit">便于更快展开业务</div>
          <div class="l-img"></div>
        </div>

        <div class="s-block b1">
          <p>长按识别下方二维码，添加您的专属客服</p>
          <div class="qr-code-area">
            <img :src="url" alt="" />
          </div>
        </div>

        <div class="s-block b2">
          <p>添加成功后，客服竭诚为您提供服务</p>
        </div>
      </div>
      <div class="btns">
        <van-button size="small" @click="showPicker = false">返回</van-button>
      </div>
    </div>
  </van-popup>
</template>
<script>
// import { getServiceQRCode } from "@/api";
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    bizNo: {
      type: String,
      default: ""
    },
    url: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      // url: ""
    };
  },
  computed: {
    showPicker: {
      get() {
        return this.value;
      },
      set(v) {
        this.$emit("input", v);
      }
    }
  },
  mounted() {
    // this.getUrl();
  },
  methods: {
    // async getUrl() {
    //   try {
    //     const data = await getServiceQRCode(this.bizNo);
    //     this.url = data.customerServiceUrl;
    //   } catch (error) {
    //     this.$errMsg(error);
    //   }
    // }
  }
};
</script>
<style lang="scss" scoped>
.service-pop {
  background-color: #d4e9ffff;
  .page-wrap {
    height: 100vh;
    width: 100vw;
    position: relative;
    .top-bg {
      position: absolute;
      top: 0;
      left: 0;
      width: 750px;
      height: 922px;
      background-image: url("/images/service/top.png");
      background-position: 0 0;
      background-size: 100% 100%;
    }
    .bottom-bg {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 750px;
      height: 438px;
      background-image: url("/images/service/bottom.png");
      background-position: 0 0;
      background-size: 100% 100%;
    }
    .page-main {
      height: 100vh;
      width: 100vw;
      position: relative;
      padding: 0 32px;
      .header {
        height: 280px;
        position: relative;
        .tit {
          position: absolute;
          top: 84px;
          width: 332px;
          height: 54px;
          background-image: url("/images/service/tit.png");
          background-position: 0 0;
          background-size: 100% 100%;
        }
        .sub-tit {
          position: absolute;
          top: 156px;
          font-weight: 400;
          font-size: 28px;
          color: #333333;
          line-height: 40px;
        }
        .l-img {
          position: absolute;
          top: 38px;
          right: 8px;
          width: 286px;
          height: 252px;
          background-image: url("/images/service/l-img.png");
          background-position: 0 0;
          background-size: 100% 100%;
        }
      }
      .s-block {
        box-shadow: 0px 4px 8px 0px rgba(0, 91, 175, 0.12);
        border-radius: 32px;
        display: flex;
        flex-direction: column;
        align-items: center;
        background: #fff;
        position: relative;
        &::before {
          content: "";
          display: block;
          position: absolute;
          top: -22px;
          left: 0;
          width: 176px;
          height: 64px;
          background-position: 0 0;
          background-size: 100% 100%;
        }
        &.b1 {
          width: 686px;
          height: 790px;
          margin-top: 20px;
          &::before {
            background-image: url("/images/service/step-1.png");
          }
        }
        &.b2 {
          width: 686px;
          height: 192px;
          margin-top: 54px;
          &::before {
            background-image: url("/images/service/step-2.png");
          }
        }
        p {
          margin-top: 88px;
          font-weight: 600;
          font-size: 28px;
          color: #333333;
          line-height: 28px;
          margin-bottom: 48px;
        }
        .qr-code-area {
          width: 576px;
          height: 576px;
          border: 2px solid #1890ff33;
          border-radius: 16px;
          img {
            width: 100%;
            height: 100%;
            border-radius: 8px;
          }
        }
      }
    }
    .btns {
      border-top: 1px solid #efefef;
      height: 100px;
      display: flex;
      justify-content: space-around;
      align-items: center;
      box-shadow: 0 -5px 10px #efefef;
      .van-button {
        min-width: 160px;
      }
    }
  }
}
</style>
